import React, { useState } from "react";
import headsetIcon from "../../assets/images/information.png";
import GetStartedDialog from "./GetStartedDialog";
export default function Pricing() {
  const [open, setOpen] = useState(false);
  return (
    <section className="relative py-5 xl:py-24 px-6 overflow-hidden">
      {/* Grid background */}
      <div className="absolute inset-0 " />

      <div className="relative max-w-7xl mx-auto">
        {/* Header */}

        {/* Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Custom Plan */}
          <div>
            <div className="mb-8 xl:mb-16 text-center lg:text-left">
              <p
                className="flex items-center justify-center lg:justify-start gap-2 text-[16px] font-medium text-[#F8F8F8] leading-[1.4em] mb-4"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <span className="w-2.5 h-2.5 rounded-full bg-[#86ff9f]" />
                Work with me
              </p>
              <h2
                className="text-[24px] md:text-[32px] xl:text-[42px] font-semibold leading-[1.2em] text-[#F8F8F8]"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                Engagement <br />
                <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
                  options
                </span>
              </h2>
            </div>
            <div
              className="rounded-[28px] p-10 bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] text-[#0f2e2e]"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="mb-3">
                <div className=" flex items-start justify-start">
                  <img
                    src={headsetIcon}
                    alt="Customer Service Icon"
                    className="w-auto h-auto"
                  />
                </div>
              </div>

              <h3 className="text-[18px] md:text-[20px] font-semibold leading-[1.2em] text-[#163031] mb-3">
                Custom Development <br /> For Your Project
              </h3>

              <p className="text-[16px] font-normal leading-[1.6em] mb-8 text-[#163031]">
                Need something specific? I can help you build tailored web
                applications based on your requirements and timeline.
              </p>
              <button
                onClick={() => setOpen(true)}
                className="
  relative px-8 py-3 text-[16px] font-semibold rounded-full
  bg-[#0f2e2e] text-[#F8F8F8]
  overflow-hidden transition-all duration-300
  hover:text-black hover:shadow-lg hover:scale-105 active:scale-95

  before:absolute before:top-0 before:-left-full
  before:w-full before:h-full
  before:bg-white
  before:transition-all before:duration-500
  before:rounded-full before:z-0

  hover:before:left-0
"
              >
                <span className="relative z-10">Contact Me</span>
              </button>
            </div>
          </div>

          {/* Hourly */}
          <div
            className="relative p-7 bg-white/5 backdrop-blur-xl rounded-3xl border border-white/10 text-[#F8F8F8] overflow-hidden"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <h3 className="text-[18px] md:text-[20px] font-semibold leading-[1.2em]">
              Hourly Development
            </h3>

            <p className="text-[16px] font-normal leading-[1.6em] text-[#F8F8F8] my-3">
              Ideal for small tasks, feature updates, bug fixes, and ongoing
              development support.
            </p>

            <div className="text-[28px] md:text-[36px] xl:text-[42px] font-semibold leading-[1.6em] text-[#6bfdd9] my-3">
              ₹500
              <span className="text-[14px] md:text-[16px] xl:text-[18px] font-medium align-baseline text-[#F8F8F8]">
                /hour
              </span>
            </div>

            <ul className="space-y-4 text-[16px] leading-[1.4em] font-normal">
              {[
                "Bug Fixes & Improvements",
                "UI Enhancements",
                "API Integration",
                "Component Development",
                "Performance Optimization",
                "Technical Support",
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <span className="w-5 h-5 rounded-full bg-white text-[#1b3f3f] flex items-center justify-center text-xs">
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <button
              onClick={() => setOpen(true)}
              className="bg-[linear-gradient(90deg,#6cfcb5,#F0FF6C,#6cfcb5)]
    bg-[length:200%_100%]
    bg-left
    transition-all duration-500 ease-in-out
    hover:bg-right text-[#0f2e2e] px-8 py-3 rounded-full font-semibold mt-8"
            >
              Hire Me
            </button>
          </div>

          {/* Monthly */}
          <div
            className="relative p-7 bg-white/5 backdrop-blur-xl rounded-3xl border border-white/10 text-[#F8F8F8] overflow-hidden"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            {/* Ribbon */}
            <span className="absolute top-6 right-[-38px] rotate-45 bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] text-[#0f2e2e] px-12 py-1 text-[16px] font-semibold">
              Popular
            </span>

            <h3 className="text-[18px] md:text-[20px] font-semibold leading-[1.2em]">
              Monthly Development
            </h3>

            <p className="text-[16px] font-normal leading-[1.6em] text-[#F8F8F8] my-3">
              Dedicated development support for ongoing projects and maintenance
            </p>

            <div className="text-[28px] md:text-[36px] xl:text-[42px] font-semibold leading-[1.6em] text-[#6bfdd9] my-3">
              ₹30k
              <span className="text-[14px] md:text-[16px] xl:text-[18px] font-medium align-baseline text-[#F8F8F8]">
                /month
              </span>
            </div>

            <ul className="space-y-4 text-[16px] leading-[1.4em] font-normal">
              {[
                "Full-Stack MERN Development",
                "Feature Development",
                "Bug Fixes & Maintenance",
                "API Integration",
                "Performance Optimization",
                "Priority Support",
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <span className="w-5 h-5 rounded-full bg-white text-[#1b3f3f] flex items-center justify-center text-xs">
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <button
              onClick={() => setOpen(true)}
              className="bg-[linear-gradient(90deg,#6cfcb5,#F0FF6C,#6cfcb5)]
    bg-[length:200%_100%]
    bg-left
    transition-all duration-500 ease-in-out
    hover:bg-right text-[#0f2e2e] px-8 py-3 rounded-full font-semibold mt-8"
            >
              Hire Me
            </button>
          </div>
        </div>
      </div>
      <GetStartedDialog open={open} onClose={() => setOpen(false)} />
    </section>
  );
}
